module.exports = __webpack_public_path__ + "assets/fonts/opensans-bold_2e90d51.woff";